/**
 * 平台简介服务
 */

import { httpClient, ApiResponse } from './httpClient';
import { API_ENDPOINTS } from './api/config';

export interface PlatformInfo {
  id?: number;
  title: string;
  subtitle?: string;
  content: string;
  achievements?: string;
  statistics?: string;
  statisticsMap?: Record<string, any>;
  status: number;
  sortOrder?: number;
  createTime?: string;
  updateTime?: string;
}

export interface StatisticsConfig {
  id?: number;
  category: string;
  displayName: string; // 现在存储key_name，通过数据字典映射显示中文名称
  description?: string;
  dataType: string;
  unit?: string;
  sortOrder?: number;
  isActive?: number;
  createTime?: string;
  updateTime?: string;
}

export const platformService = {
  /**
   * 获取平台简介信息
   */
  async getInfo(): Promise<ApiResponse<PlatformInfo>> {
    return httpClient.get(API_ENDPOINTS.PLATFORM.INFO);
  },

  /**
   * 更新平台简介信息
   */
  async update(data: PlatformInfo): Promise<ApiResponse<string>> {
    return httpClient.put(API_ENDPOINTS.PLATFORM.UPDATE, data);
  },

  /**
   * 创建平台简介信息
   */
  async create(data: PlatformInfo): Promise<ApiResponse<string>> {
    return httpClient.post(API_ENDPOINTS.PLATFORM.CREATE, data);
  },

  /**
   * 获取统计数据配置
   */
  async getStatisticsConfig(): Promise<ApiResponse<StatisticsConfig[]>> {
    return httpClient.get(API_ENDPOINTS.PLATFORM.STATISTICS_CONFIG);
  },

  /**
   * 根据分类获取统计数据配置
   */
  async getStatisticsConfigByCategory(category: string): Promise<ApiResponse<StatisticsConfig[]>> {
    return httpClient.get(`${API_ENDPOINTS.PLATFORM.STATISTICS_CONFIG_BY_CATEGORY}/${category}`);
  },

  /**
   * 获取所有统计分类
   */
  async getStatisticsCategories(): Promise<ApiResponse<string[]>> {
    return httpClient.get(API_ENDPOINTS.PLATFORM.STATISTICS_CATEGORIES);
  },

  /**
   * 创建统计数据配置
   */
  async createStatisticsConfig(data: StatisticsConfig): Promise<ApiResponse<string>> {
    return httpClient.post(API_ENDPOINTS.PLATFORM.STATISTICS_CONFIG, data);
  },

  /**
   * 更新统计数据配置
   */
  async updateStatisticsConfig(data: StatisticsConfig): Promise<ApiResponse<string>> {
    return httpClient.put(API_ENDPOINTS.PLATFORM.STATISTICS_CONFIG, data);
  },

  /**
   * 删除统计数据配置
   */
  async deleteStatisticsConfig(id: number): Promise<ApiResponse<string>> {
    return httpClient.delete(`${API_ENDPOINTS.PLATFORM.STATISTICS_CONFIG}/${id}`);
  },
};